import React, { Fragment } from "react";
import { Col, Row } from "antd";
import DiscussionOrganizer from "./DiscussionOrganizer";
import Loader from "../../../common/cards/Loader";
import { isLoading } from "../../../Store/Features/EventSlice";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const Announcements = ({ event, panelFound, teamFound }) => {
  if (!panelFound && !teamFound) {
    return <Navigate to="/" />; // Redirect to home or another page
  }

  const loading = useSelector(isLoading);
  return loading ? (
    <Loader fullpage loading={"white"} text={"Please Wait fetching Event details"} />
  ) : (
    <Fragment>
      <Row className="rowPadding" justify="center">
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 24, order: 3 }}
          lg={{ span: 12, order: 2 }}>
          {Object.keys(event).length > 0 && (
            <DiscussionOrganizer panelFound={panelFound} teamFound={teamFound} />
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

export default Announcements;
